import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import FolderModel from "../Models/FolderModel";

export default class DocumentsService {
  msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  public async get(): Promise<FolderModel> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();
    const data = await fetch(baseUrl + "/api/getdocuments", {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
    }).then(function (response) {
      return response.json();
    });

    return data;
  }

  private async acquireAccessToken() {
    const account = this.msalInstance.getActiveAccount();
    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const authResult = await this.msalInstance.acquireTokenSilent({
      ...apiLoginRequest,
      account: account,
    });

    return authResult.accessToken;
  }
}
